import { useEffect } from "react";
import { useAddCheckList, useEditCheckList, useFetchChecklists, useUpdateChecklists } from "../mutation";

export const useFetchChecklist = (stageID: string) => {

    const checkList = useFetchChecklists();
    const updateCheckList = useUpdateChecklists();
    const addCheckList = useAddCheckList();
    const editCheckList = useEditCheckList();

    const fetch = async () => {
        await checkList.mutateAsync({ search_term: null, object_type: ['checklist'], object_id: Number(stageID) || null, my_tasks: false });
    };

    const create = async (payload: { task_name: string; user_id: number; is_evidence_required: boolean; is_required: boolean; object_type: string; object_id: number | null; }) => {
        await addCheckList.mutateAsync({ payload });
        await fetch();
    };

    const edit = async (checkListID: string, payload: { task_name: string; user_id: number; is_evidence_required: boolean; is_required: boolean; object_type: string; object_id: number | null; }) => {
        await editCheckList.mutateAsync({ payload, checkListID });
        await fetch();
    };

    const update = async (checkListID: string, object_type: string, object_id: number | null) => {
        const payload = { status: "completed", object_type: object_type, object_id: object_id };
        await updateCheckList.mutateAsync({ checkListID, payload });
        await fetch();
    };

    useEffect(() => {
        fetch();
    }, []);

    return {
        isPending: checkList.isPending,
        isUpdating: updateCheckList.isPending,
        isAdding: addCheckList.isPending,
        isEditing: editCheckList.isPending,
        data: checkList.isSuccess ? checkList?.data?.data?.rows : [],
        handleUpdateCheckList: update,
        handleAddChecklist: create,
        handleEditChecklist: edit,
    };

};